import type { MetaFunction } from 'react-router';
import { Link } from 'react-router';

export const meta: MetaFunction = () => {
  return [
    { title: 'Play KQ' },
    { name: 'description', content: 'Killer Queen Arcade Info & Tools' },
  ];
};

export default function Index() {
  return (
    <div className="size-full min-h-svh grid place-content-center">
      <div className="font-sans bg-black p-8 w-96 border rounded border-slate-800 space-y-6">
        <h1 className="text-sm tracking-wide pb-4 border-b border-b-slate-800 text-slate-300 uppercase">
          Welcome to Play KQ
        </h1>
        <div className="grid grid-cols-2 gap-4">
          <Link
            to="/draft"
            className="inline-block rounded bg-teal-700 text-white py-2 px-4 text-center"
          >
            Drafter
          </Link>
          <Link
            to="/hiveops"
            className="inline-block rounded bg-teal-700 text-white py-2 px-4 text-center"
          >
            Hive OPS
          </Link>
        </div>
      </div>
    </div>
  );
}
